import { palette } from "@bonusx-global/bx-design-system";
import { styled } from "@mui/material";
import Backdrop from "@mui/material/Backdrop";

const OVER_THE_SKY_Z_INDEX = 1200;

export const BackdropOnTop = styled(Backdrop)`
  background: ${palette.background?.paper};
  opacity: 0;
  z-index: ${OVER_THE_SKY_Z_INDEX};
`;
